module.exports = __webpack_public_path__ + "static/headshot-lauren-pearl.d815874f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-lauren-pearl.jpg
// module id = 125
// module chunks = 35783957827783 152909308826437